var cc = initCookieConsent();
var lang = document.querySelector('html').getAttribute('lang');

// run plugin with your configuration
cc.run({
  current_lang: lang,
  autoclear_cookies: true, // default: false
  page_scripts: true, // default: false

  // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
  // delay: 0,                               // default: 0
  // auto_language: null                     // default: null; could also be 'browser' or 'document'
  // autorun: true,                          // default: true
  // force_consent: false,                   // default: false
  // hide_from_bots: false,                  // default: false
  // remove_cookie_tables: false             // default: false
  // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
  // cookie_expiration: 182,                 // default: 182 (days)
  // cookie_necessary_only_expiration: 182   // default: disabled
  // cookie_domain: location.hostname,       // default: current domain
  // cookie_path: '/',                       // default: root
  // cookie_same_site: 'Lax',                // default: 'Lax'
  // use_rfc_cookie: false,                  // default: false
  // revision: 0,                            // default: 0

  onFirstAction: function (user_preferences, cookie) {
    // callback triggered only once
  },

  onAccept: function (cookie) {
    // ...
  },

  onChange: function (cookie, changed_preferences) {
    // ...
  },

  languages: {
    'en': {
      consent_modal: {
        title: 'Cookies on this page',
        description: 'We use cookies to offer better performance and a better experience to you. By agreeing, you consent to save cookies on your device in accordance with the STIHL <a target="_blank" href="https://www.stihl.com/imprint-privacy-policy.aspx?tab=2"> Privacy Policy.</a><br><button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
        primary_btn: {
          text: 'Accept all',
          role: 'accept_all' // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Reject all',
          role: 'accept_necessary' // 'settings' or 'accept_necessary'
        }
      },
      settings_modal: {
        title: 'Cookie preferences',
        save_settings_btn: 'Save settings',
        accept_all_btn: 'Accept all',
        reject_all_btn: 'Reject all',
        close_btn_label: 'Close',
        blocks: [{
          title: 'Cookie usage',
          description: 'We use cookies to offer better performance and a better experience to you. By agreeing, you consent to save cookies on your device in accordance with the STIHL <a target="_blank" href="https://www.stihl.com/imprint-privacy-policy.aspx?tab=2"> Privacy Policy.</a>'
        }, {
          title: 'Analytics cookies',
          toggle: {
            value: 'analytics', // your cookie category
            enabled: false,
            readonly: false
          }
        }]
      }
    },
    'de': {
      consent_modal: {
        title: 'Cookies auf dieser Seite',
        description: 'Wir nutzen Cookies um Ihnen eine bessere Leistung und ein besseres Erlebnis bieten zu können. Bei Zustimmung erlauben Sie es, das Cookies auf Ihrem Gerät gespeichert werden. Um mehr über die Verwaltung von Cookies zu erfahren, klicken Sie <a target=\"_blank\" href=\"https://corporate.stihl.de/impressum.aspx?tab=3#dataprivacy\"> hier.</a><br><button type="button" data-cc="c-settings" class="cc-link">Individuelle Auswahl</button>',
        primary_btn: {
          text: 'Alle akzeptieren',
          role: 'accept_all' // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Alle ablehnen',
          role: 'accept_necessary' // 'settings' or 'accept_necessary'
        }
      },
      settings_modal: {
        title: 'Cookie-Einstellungen',
        save_settings_btn: 'Einstellungen speichern',
        accept_all_btn: 'Alle akzeptieren',
        reject_all_btn: 'Alle ablehnen',
        close_btn_label: 'Schließen',
        blocks: [{
          title: 'Verwendung von Cookies',
          description: 'Wir nutzen Cookies um Ihnen eine bessere Leistung und ein besseres Erlebnis bieten zu können. Bei Zustimmung erlauben Sie es, Cookies auf Ihrem Gerät zu speichern. Um mehr über die Verwaltung von Cookies zu erfahren, klicken Sie <a target=\"_blank\" href=\"https://corporate.stihl.de/impressum.aspx?tab=3#dataprivacy\"> hier.</a>'
        }, {
          title: 'Analytic-Cookies',
          toggle: {
            value: 'analytics', // your cookie category
            enabled: false,
            readonly: false
          }
        }]
      }
    }
  }
});
